export default "__VITE_ASSET__96ccba27__"